export default "__VITE_ASSET__DMpCPuQl__"